/**
 * Drawer Menu Accordion
 * Intercepts accordion-toggle clicks and expands inline instead of navigating
 */

(function() {
  'use strict';

  console.log('🎯 Accordion script loaded');

  const CLASSES = {
    visible: 'visible',
    accordionExpanded: 'accordion-expanded'
  };

  function init() {
    console.log('🔍 Initializing accordion...');
    
    // Wait a bit for the drawer to be in the DOM
    setTimeout(() => {
      const drawerMenu = document.querySelector('.drawer-menu');
      
      if (!drawerMenu) {
        console.warn('❌ Drawer menu not found');
        return;
      }

      console.log('✅ Drawer menu found, attaching listener');

      // Remove any existing listener first
      drawerMenu.removeEventListener('click', handleClick, true);
      
      // Attach in capture phase to intercept before theme.js
      drawerMenu.addEventListener('click', handleClick, true);
      
      console.log('✅ Accordion initialized successfully');
    }, 100);
  }

  function handleClick(e) {
    // Find if we clicked an accordion toggle
    const toggle = e.target.closest('[data-item="accordion-toggle"]');
    
    if (!toggle) {
      return; // Not our concern, let theme.js handle it
    }

    console.log('🎯 Accordion toggle clicked!');
    
    // Stop the event completely
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const childMenu = toggle.nextElementSibling;
    
    if (!childMenu || !childMenu.classList.contains('drawer-menu__list--sub')) {
      console.warn('❌ No child menu found');
      return;
    }

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    console.log('📊 Current state:', isExpanded ? 'expanded' : 'collapsed');

    if (isExpanded) {
      // Collapse - get current height first, then animate to 0
      console.log('⬆️ Collapsing...');
      
      // Get current height
      const currentHeight = childMenu.scrollHeight;
      childMenu.style.maxHeight = currentHeight + 'px';
      
      // Force reflow to apply the current height
      void childMenu.offsetHeight;
      
      // Now animate to 0
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove(CLASSES.accordionExpanded);
      childMenu.classList.remove(CLASSES.visible);
      childMenu.setAttribute('aria-hidden', 'true');
      childMenu.style.maxHeight = '0px';
      
    } else {
      // Expand - calculate and set height immediately
      console.log('⬇️ Expanding...');
      
      // Clear any lingering transitions immediately
      childMenu.style.transition = 'none';
      
      // Get the height we need
      childMenu.style.maxHeight = 'none';
      childMenu.style.visibility = 'visible';
      const targetHeight = childMenu.scrollHeight;
      
      // Reset to start position
      childMenu.style.maxHeight = '0px';
      
      // Force reflow
      void childMenu.offsetHeight;
      
      // Re-enable transitions
      childMenu.style.transition = '';
      
      // Set attributes
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add(CLASSES.accordionExpanded);
      childMenu.classList.add(CLASSES.visible);
      childMenu.setAttribute('aria-hidden', 'false');
      
      // Trigger the animation
      requestAnimationFrame(() => {
        childMenu.style.maxHeight = targetHeight + 'px';
      });
      
      // After transition, allow content to grow naturally
      setTimeout(() => {
        if (childMenu.classList.contains(CLASSES.visible)) {
          childMenu.style.maxHeight = 'none';
        }
      }, 500); // Match max-height transition duration
    }
  }

  // Initialize immediately and also on DOM ready
  init();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-init when drawer opens
  document.addEventListener('drawer-menu:open', () => {
    console.log('🚪 Drawer opened, re-initializing...');
    init();
  });

})();
